import * as React from 'react';
import {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {AppState} from '../../../../redux';
import {change, getFormValues} from 'redux-form';
import {Forms} from '../../../models/forms';
import {VisImpStatus, VisuallyImpairedSettings} from '../../../models/visuallyImpairedSettings';

export const StatusSwitcherWrapper: React.FC<{render: React.FC<{active: boolean; onPress: () => void}>}> = ({
  render,
}) => {
  const dispatch = useDispatch();
  const formData = useSelector<AppState, VisuallyImpairedSettings>(
    (state) => getFormValues(Forms.visuallyImpaired)(state) as VisuallyImpairedSettings,
  );
  const visuallyImpaired = formData?.visuallyImpaired || VisImpStatus.Disabled;
  const onPress = useCallback(() => {
    dispatch(
      change(
        Forms.visuallyImpaired,
        'visuallyImpaired',
        visuallyImpaired === VisImpStatus.Disabled ? VisImpStatus.Active : VisImpStatus.Disabled,
      ),
    );
  }, [visuallyImpaired]);
  return render({
    active: visuallyImpaired === VisImpStatus.Active,
    onPress,
  });
};
